import { useLocation } from "react-router-dom";

import urls from "web/constants/urls";

import { useGetBanksQuery } from "web/features/pointsBank/pointsBankApiSlice";

import Customer from "./Customer";

const NavigationPanelAdditional = () => {
  const { data: dataBanks, isLoading, isError } = useGetBanksQuery();
  const { total: totalPoints } = dataBanks || {};
  const { pathname } = useLocation();
  const showSkeleton = isLoading || isError;

  switch (true) {
    case typeof pathname !== "string": {
      return null;
    }
    case urls.customer === pathname: {
      return <Customer totalPoints={totalPoints} showSkeleton={showSkeleton} />;
    }
    default:
      return null;
  }
};

export default NavigationPanelAdditional;
